import { render, staticRenderFns } from "./MinusMoreIcon.vue?vue&type=template&id=06d22722"
import script from "./MinusMoreIcon.vue?vue&type=script&lang=js"
export * from "./MinusMoreIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports